const colors = {
  primaryBlue: '#3949AB',
  secondaryBlue: '#191838',
  gray: '#808080',
  powderBlue: '#b0e0e6',
};

export const topAndBottomBarColor = colors.secondaryBlue;
export const eventTabsColor = colors.secondaryBlue;
export const chatHandleColor = colors.gray;
export const taggedContColor = colors.powderBlue;
export const chatHandleInMsg = colors.primaryBlue;
